<template>
  <sModal
    v-if="isEnabledChangeContactPerson"
    v-model="changeContactPersonDialog"
    :data-qa="'modal-change-contact-person-' + (changeContactPersonDialog ? 'open' : 'close')"
    persistent
    :title="$t('Tenders.ChangeContactPerson')"
    width="392px">
    <template v-slot:activator>
      <MenuItem
        class="h11-links"
        data-qa="item-change-contact-person"
        icon="persons"
        :label="$t('Tenders.ChangeContactPerson')"
        @click="showDialog"/>
    </template>
    <TenderContactPersonItem
      :loading="loading"
      :peoples="contactPersons"
      :value.sync="newContactPerson"/>
    <template #footer>
      <sButton
        key="btn-apply"
        data-qa="btn-modal-change-contact-person-apply"
        :disabled="loading || !newContactPerson || !newContactPerson.contactId"
        @click="apply()">
        {{ $t('Common.Apply') }}
      </sButton>
    </template>
  </sModal>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import TenderContactPersonItem from 'components/tenderCreation/block/TenderContactPersonItem.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'dialogChangeContactPerson',
  data() {
    return {
      changeContactPersonDialog: false,
      newContactPerson: null,
      contactPersons: [],
      loading: false,
    }
  },
  methods: {
    updateContactPerson(newValue) {
      this.newContactPerson = newValue
    },
    closeDialog() {
      this.changeContactPersonDialog = false
      this.newContactPerson = null
      this.loading = false
    },
    showDialog() {
      this.newContactPerson = {
        contactId: this.tender?.contactPerson?.code,
        name: this.tender?.contactPerson?.name,
        email: this.tender?.contactPerson?.email,
        phone: this.tender?.contactPerson?.telephone,
        login: this.tender?.contactPerson?.email
      }
      if (this.contactPersons?.length) {
        this.changeContactPersonDialog = true
        return
      }

      let mapFunc = item => ({...item, phone: item.phone || '', name: item.name || item.email || '', hidden: item.hidden})
      let sortFunc = (a, b) => a?.name?.localeCompare(b?.name)
      
      api.tenderContactPersons()
        .then(res => {
          this.contactPersons = res?.map(mapFunc)?.sort(sortFunc) || []
          this.changeContactPersonDialog = true
        })
    },
    apply() {
      if (this.newContactPerson?.contactId === this.tender?.contactPerson?.code) {
        this.closeDialog()
        return
      }
      this.loading = true
      api.changeTenderContactPerson(this.tender?.tenderId, this.newContactPerson?.contactId)
        .then(res => {
          if (res) {
            this.closeDialog()
            this.$root.$emit('tenderUpdate', true)
          }
        })
        .catch(() => {
          this.$notice.warning({
            title: this.$t('Common.ErrorTitle'),
            showClose: true,
            progress: true,
            duration: 20
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    isTerminalStatus() {
      return [this.statuseKeys.COMPLETED, this.statuseKeys.CANCELED, this.statuseKeys.PURCHASE_NOT_PLACED].includes(this.tender?.tenderStatus?.id)
    },
    isEnabledChangeContactPerson() {
      if (!this.tender?.contactPerson || this.isTerminalStatus) {
        return false
      }
      if (this.tender?.contactPerson?.code === this.$store.getters['GET_USER']?.tenderSettings.contactId) {
        return true
      }
      const accessRoles = ['COMMERCIALORGANIZERCOMPANYADMIN', 'QA', 'ADMIN', 'FRONTOFFICEEMPLOYEE', 'FRONTOFFICEADMIN'] 
      return this.$store.getters['GET_USER']?.tenderSettings?.accessRole?.some(role => accessRoles.includes(role))
    }
  },
  components: {
    MenuItem,
    TenderContactPersonItem,
  },
  created() {},
  props: {
    tender: {
      type: Object,
      required: true
    }
  },
}
</script>
<style scoped lang="scss">
</style>
